module.exports = __webpack_public_path__ + "img/p61-baiqiang-2017.5b57e7f8.jpg";